import { StateObserver } from '../../../lib/pattern/StateMachine';
import { shouldShuffle } from '../../util/matchTools';
import { IPhase, PhaseSystem } from '../PhaseSystem';

/*
    handles game session transfiguration phase - mainly for applying extra power blocks
*/
export class TransfigurationPhase implements StateObserver, IPhase {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _system: PhaseSystem;

  // init
  //-------------------------------------------------------------------------
  constructor(system: PhaseSystem) {
    this._system = system;
  }

  // impl
  //-------------------------------------------------------------------------
  public async enter() {
    const system = this._system;
    if (!system.scene) return;

    await system.scene.powerBlockSystem.applyExtraPowerups();

    // Skip if the snece got destroyed during the powerup application.
    if (!system.scene) return;

    // If the resulting board needs to be shuffled, go to the shuffle phase.
    if (shouldShuffle(system.scene)) {
      system.phase = 'shuffle';
      return;
    }

    if (system.scene.sessionEntity.c.phase.activations > 0) {
      // If there are any activations, go to the active phase.
      system.phase = 'active';
    } else {
      // Otherwise, go to the input phase.
      system.phase = 'input';
    }
  }

  public async leave() {
    if (!this._system.scene) return;
    // Extra powerups should be available only on 1st turn (tapCount 0) or 2nd turn (tapCount 1).
    if (this._system.scene.getRound() === 2) {
      // Clear all queued powerups after the second move, if there are any
      this._system.scene.powerBlockSystem.clearExtraPowerups();
    }
  }

  public step() {}
}
